// Routes owned by the Account module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const accountPaths = {
    account: '/account',
    // Unreferenced: no paths.* caller; route is live and linked by URL elsewhere.
    accountRegulations: '/account/regulations',
    accountOncall: '/account/oncall',
    accountMyIncomes: '/account/my-incomes',
    accountMyRatings: '/account/my-ratings',
    accountCustomerEvents: '/account/customer-events',
} as const
